// Shared status and admin_transfer options for Cutting / Trimming / NOC status update pages

export const STATUS_OPTIONS = [
  "Raised",
  "Reviewed",
  "Panchanama Scheduled",
  "Panchanama Completed",
  "Advertisment Scheduled",
  "Advertisment Completed",
  "Payment Initiated",
  "Tree Plantation Details Approved",
  "Raised The Tree Plantation Request",
  "Payment Completed",
  "Final Permission Completed",
  "Re-Submitted",
  "Rejected",
  "Objection Completed",
  "Partially Uploaded Document",
  "Application Transferred To Hon. Divisional Officer",
  "Application Transferred To Hon. Garden Superintendent",
  "Application Transferred To Hon. Additional Commissioner",
  "Application Transferred To Hon. Commissioner",
  "Application Transferred To Hon. Divisional Commissioner",
  "Reviewed And Payment Initiated",
  "Payment Completed And Tree Plantation In Process",
  "Tree Plantation Completed",
  "Tree Plantation Images Uploaded",
  "Final Review Completed",
  "Application Transferred To Tree Officer",
  "Application Transferred To Deputy Commissioner",
  "Application Transferred To Assistant Garden Officer",
  "Application Transferred To Hon. Deputy Commissioner",
  "Application Has reverted to Additional Commissioner By Municipal Commissioner",
  "Application Has reverted to Deputy Commissioner By Municipal Commissioner",
  "Application Has reverted to Deputy Commissioner By Additional Commissioner",
  "Application Has reverted to Assistant Garden Officer By Dy. Commissioner Assistant",
  "Application Has reverted to Tree Officer By Dy. Commissioner Assistant",
  "Application Has reverted to Garden Superintendent By Dy. Commissioner Assistant",
  "Application Has reverted to Garden Assistant By Dy. Commissioner Assistant",
  "Application Has reverted to Tree Officer By Assistant Garden Officer",
  "Application Has reverted to Garden Superintendent By Assistant Garden Officer",
  "Application Has reverted to Garden Assistant By Assistant Garden Officer",
  "Application Has reverted to Garden Superintendent By Tree Officer",
  "Application Has reverted to Garden Assistant By Tree Officer",
  "Application Has reverted to Garden Assistant By Garden Superintendent",
  "Application Has reverted to Assistant Garden Officer By Dy. Commissioner Assistant",
];

export const ADMIN_TRANSFER_OPTIONS = [
  "",
  "divisionalofficertransfer",
  "gardensuperintendenttransfer",
  "gardenassistanttransfer",
  "treeofficertransfer",
  "assistantgardenofficertransfer",
  "deputycommissionertransfer",
  "additionaltransfer",
  "commisionertransfer",
  "gardenassistentofficertransfer",
];
